import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
};

const IconButton = styled.div`
    position: absolute;
    right: 1rem;
    top: 2rem;
`;

const Container = styled.div`
    width: 80%;
    margin: auto;
`;

const TutrialImage = styled.img`
    width: 85%;
    margin: 3rem auto;
    outline: none;
    &:hover {
        outline: none;
    }
`;

const Tutrial = (props) => {
    return (
        <div style={{ position: "relative", zIndex: 20000, marginTop: "-65px", backgroundColor: "#fff", }}>
            <IconButton onClick={props.closeTutrial}>
                <CloseIcon />
            </IconButton>
            <Container>
                <Slider {...settings}>
                    <div>
                        <TutrialImage src={props.image1} alt="" srcset="" />
                    </div>
                    <div>
                        <TutrialImage src={props.image2} alt="" srcset="" />
                    </div>
                    {props.image3 && (
                    <div>
                        <TutrialImage src={props.image3} alt="" srcset="" />
                    </div>)}
                    {props.image4 && (
                    <div>
                        <TutrialImage src={props.image4} alt="" srcset="" />
                    </div>)}
                </Slider>
            </Container >
        </div>)
};

export default Tutrial;